import { TMessagesRequest } from "src/@types/messages";
import GenericDAO from "../GenericDAO";

const route = "/v1/clients/:id/messages";

const getById = async (data: TMessagesRequest) => GenericDAO.getByIdWithParams(route, parseInt(data.clientId), [
    {
        name: "page",
        value: data.page as any,
    },
    {
        name: "perPage",
        value: data.perPage as any,
    }
], true);

export default {
    getById
};